
import {get, toInteger} from 'lodash';

import BaseService from '../../middleware/BaseService';

const FETCH_SUMMARY_ENDPOINT = '/medias/report/summary';
const FETCH_DRIVER_SUMMARY_ENDPOINT = '/medias/report/driver/summary';
const FETCH_DRIVER_DETAILS_ENDPOINT = '/medias/report/driver/list';
const FETCH_ADMIN_SUMMARY_ENDPOINT = '/report/admin/media';

class ReportService extends BaseService {
  prefix = FETCH_SUMMARY_ENDPOINT;

  async loadSummaryReport(_params, options) {
    const params = this.parseParams(_params);
    const response = await this.search(params, FETCH_SUMMARY_ENDPOINT, options);
    return response;
  }

  async loadSummaryDriverReport(_params, options) {
    const params = this.parseParams(_params);
    const response = await this.search(params, FETCH_DRIVER_SUMMARY_ENDPOINT, options);
    return response;
  }

  async loadSummaryDetailsReport(_params, options) {
    const params = this.parseParams(_params);
    if (!params.driverId) {
      return false;
    }
    // TODO: fix this workaround when we implement pagination.
    // No driver has this amount of medias in 6 months.
    params.page = 0;
    params.pageSize = 10000;
    const response = await this.search(params, FETCH_DRIVER_DETAILS_ENDPOINT, options);
    return response;
  }

  async loadAdminSummaryReport(_params, options) {
    const params = {
      timezone: _params.timezone,
      language: localStorage.getItem('language')
    };

    return await this.search(params, FETCH_ADMIN_SUMMARY_ENDPOINT, options);
  }

  parseParams(_params) {
    let driverId = get(_params, 'chips[0].id', null);

    const params = {
      timezone: _params.timezone,
      terminalRestriction: _params.terminalRestriction,
      fromDate: _params.startTime,
      toDate: _params.endTime,
      terminal: get(_params, 'terminals', null),
      download: get(_params, 'download', false),
      language: localStorage.getItem('language')
    };
    if (driverId) {
      params.driverId = driverId;
    }
    return params;
  }

  async downloadReport(reportType, params) {
    params = {
      download: true,
      ...params
    };

    const options = {
      headers: {
        'Content-Type': 'application/octet-stream'
      }
    };

    let loadFunction = this.loadSummaryReport;

    if (reportType.isSummaryDriverDetail()) {
      loadFunction = this.loadSummaryDetailsReport;
    } else if (reportType.isSummaryByDriver()) {
      loadFunction = this.loadSummaryDriverReport;
    } else if (reportType.isAdminReport()) {
      loadFunction = this.loadAdminSummaryReport;
    }

    return await loadFunction.call(this, params, options);
  }
}

export default new ReportService();
